import {fetchWithToken} from '@hublot-io/core-api/client'

import {PoissonCode} from '@/dto/CodePoisson'
import {Poisson} from '@/dto/Poisson'
import CommonUtils from '@/utils/commonUtils'
import SentenceUtils from '@/utils/sentenceUtils'

import {Label} from '../dto/Label'
import {PoissonConditionnement} from '../dto/PoissonConditionnement'
import {PoissonDenomination} from '../dto/PoissonDenomination'
import {PoissonOrigine} from '../dto/PoissonOrigine'
import {PoissonQualite} from '../dto/PoissonQualite'
import {PoissonTaille} from '../dto/PoissonTaille'
import {Preparation} from '../dto/Preparation'
import {ProduitLS} from '../dto/ProduitLS'
import {ProduitTransforme} from '../dto/ProduitTransforme'
import config from '../utils/apiUtils'
import DtoUtils from '../utils/dtoUtils'


const KeyboardService = {

  idEntier: 1,
  idHuitre: [276, 288],
  ignoreProps: ['idCode', 'code', 'idCodeMagasin', 'plu', 'idDenomination', 'ean'],

  // change get source to get by client

  copyToDto: fishkeyboard => Object.assign({}, fishkeyboard, {
    poisson: DtoUtils.toDtos(fishkeyboard.poisson, Poisson),
    conditionnement: DtoUtils.toDtos(fishkeyboard.conditionnement, PoissonConditionnement),
    denomination: DtoUtils.toDtos(fishkeyboard.denomination, PoissonDenomination),
    label: DtoUtils.toDtos(fishkeyboard.label, Label),
    categorie: fishkeyboard.categorie,
    origine: DtoUtils.toDtos(fishkeyboard.origine, PoissonOrigine),
    preparation: DtoUtils.toDtos(fishkeyboard.preparation, Preparation),
    qualite: DtoUtils.toDtos(fishkeyboard.qualite, PoissonQualite),
    taille: DtoUtils.toDtos(fishkeyboard.taille, PoissonTaille),
    produitTransforme: DtoUtils.toDtos(fishkeyboard.produitTransforme, ProduitTransforme),
    produitLS: DtoUtils.toDtos(fishkeyboard.produitLS, ProduitLS),
    codePoisson: DtoUtils.toDtos(fishkeyboard.codePoisson, PoissonCode)
  }),
  getKeyboard: () => fetchWithToken(`${config().fishService}/code/`, {method: 'GET'})
    .then(response => response.json())
    .then(fishkeyboard => KeyboardService.copyToDto(fishkeyboard)),
  filterByCode: (state, nextProps, codes) => {
    const filteredCodes = codes.filter(code => state.every(stateElement => code[stateElement.getIdAttribute()] === stateElement[stateElement.getIdAttribute()]))
    return nextProps.filter(prop => {
      const listCode = filteredCodes.map(code => code[prop.getIdAttribute()])
      return listCode.includes(prop[prop.getIdAttribute()])
    })
  },
  retreivePlu: (line, fishDatabase) => {
    if (line.idCodeMagasin) {
      return [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(code => code.idCodeMagasin === line.idCodeMagasin).plu || ''
    }
    return [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(code => code.idCode === line.idCode).plu || ''
  },
  retreiveLS: (line, fishDatabase) => {
    if (line.idCodeMagasin) {
      return [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(code => code.idCodeMagasin === line.idCodeMagasin).idProduitLS || null
    }
    return [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(code => code.idCode === line.idCode).idProduitLS || null
  },
  formatResultToDisplay: result => result.map(stateElement => stateElement.formatToDisplay()),
  formatCreateToDisplay: (result, fishDatabase) => result.map(stateElement => stateElement.formatToCreate(fishDatabase.denomination, fishDatabase.conditionnement)),
  generateResult: (state, input, fishDatabase, codePoisson = fishDatabase.codePoisson, filteringFn = KeyboardService.filterByCode) => {
    if (!(!isNaN(input) && state.length === 0) || state.length > 0 || (state.length === 0 && input.length === 0)) {
      const stateWithEntier = KeyboardService.checkEntier(state, fishDatabase.conditionnement)
      // List of searchable element
      const result = [
        KeyboardService.filterAndFormat(KeyboardService.getQualite(stateWithEntier, input, fishDatabase.qualite), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
        KeyboardService.filterAndFormat(KeyboardService.getOrigine(stateWithEntier, input, fishDatabase.origine), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
        KeyboardService.filterAndFormat(KeyboardService.getTaille(stateWithEntier, input, fishDatabase.taille), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
        KeyboardService.filterAndFormat(KeyboardService.getPreparation(stateWithEntier, input, fishDatabase.preparation), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
        KeyboardService.filterAndFormat(KeyboardService.getLabel(stateWithEntier, input, fishDatabase.label), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
        CommonUtils.limit(KeyboardService.filterAndFormat(KeyboardService.getPoisson(stateWithEntier, input, fishDatabase.poisson), input, stateWithEntier, codePoisson, fishDatabase, filteringFn)),
        KeyboardService.filterAndFormat(KeyboardService.getProduitTransforme(stateWithEntier, input, fishDatabase.produitTransforme), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
        KeyboardService.filterAndFormat(KeyboardService.getProduitLS(state, input, fishDatabase.produitLS), input, state, codePoisson, fishDatabase, filteringFn),
        KeyboardService.formatResultToDisplay(KeyboardService.getConditionnement(stateWithEntier, input, fishDatabase.conditionnement, codePoisson), fishDatabase)
      ].reduce((prec, now) => prec.concat(now), []).sort((nextProps1, nextProps2) => ((nextProps1.created === nextProps2.created) ? 0 : nextProps1.created ? -1 : 1))
      return result
    }
    return KeyboardService.formatResultToDisplay(KeyboardService.getByCode(state, input, fishDatabase, codePoisson))
  },
  // generateResult: (state, input, fishDatabase, codePoisson = fishDatabase.codePoisson, filteringFn = KeyboardService.filterByCode) => {
  //   if (!(!isNaN(input) && state.length === 0) || state.length > 0 || (state.length === 0 && input.length === 0)) {
  //     const stateWithEntier = KeyboardService.checkEntier(state, fishDatabase.conditionnement)
  //     const result = [
  //       KeyboardService.filterAndFormat(KeyboardService.getQualite(stateWithEntier, input, fishDatabase.qualite), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
  //       KeyboardService.filterAndFormat(KeyboardService.getOrigine(stateWithEntier, input, fishDatabase.origine), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
  //       KeyboardService.filterAndFormat(KeyboardService.getTaille(stateWithEntier, input, fishDatabase.taille), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
  //       KeyboardService.filterAndFormat(KeyboardService.getPreparation(stateWithEntier, input, fishDatabase.preparation), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
  //       KeyboardService.filterAndFormat(KeyboardService.getLabel(stateWithEntier, input, fishDatabase.label), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
  //       CommonUtils.limit(KeyboardService.filterAndFormat(KeyboardService.getPoisson(stateWithEntier, input, fishDatabase.poisson), input, stateWithEntier, codePoisson, fishDatabase, filteringFn)),
  //       KeyboardService.filterAndFormat(KeyboardService.getProduitTransforme(stateWithEntier, input, fishDatabase.produitTransforme), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
  //       KeyboardService.filterAndFormat(KeyboardService.getProduitLS(stateWithEntier, input, fishDatabase.produitLS), input, stateWithEntier, codePoisson, fishDatabase, filteringFn),
  //       KeyboardService.formatResultToDisplay(KeyboardService.getConditionnement(stateWithEntier, input, fishDatabase.conditionnement, codePoisson), fishDatabase),
  //     ].reduce((prec, now) => prec.concat(now), []).sort((nextProps1, nextProps2) => ((nextProps1.created === nextProps2.created) ? 0 : nextProps1.created ? -1 : 1))
  //     return result
  //   }
  //   return CommonUtils.limit(KeyboardService.formatResultToDisplay(KeyboardService.getByCode(state, input, fishDatabase), fishDatabase))
  // },
  retreiveSentenceWithQte(code, conditionnementVentes, fiskeyboard, conditionnementVenteProperty = 'idConditionnementVente', conditionnementCommandes = [], conditionnementCommandeProperty = 'codesCommande', raccourci = false, idCodeMagasin) {
    const sentence = KeyboardService.retreiveSentence(code, fiskeyboard, raccourci, idCodeMagasin)
    const conditionnement = conditionnementVentes.find(conditionnementVente => conditionnementVente.idConditionnementVente === code[conditionnementVenteProperty]).nom
    const conditionnementForCommande = code[conditionnementCommandeProperty] && code[conditionnementCommandeProperty].length > 0 ? ` (${code[conditionnementCommandeProperty].map((code, index) => (Number.isInteger(code.idConditionnementCommande)
      ? index === 0
        ? `${String(conditionnementCommandes.find(conditonnementCommande => conditonnementCommande.idConditionnementCommande === code.idConditionnementCommande).nom).toLowerCase()}`
        : ` ${String(conditionnementCommandes.find(conditonnementCommande => conditonnementCommande.idConditionnementCommande === code.idConditionnementCommande).nom).toLowerCase()}`
      : ''))})` : ''
    return SentenceUtils.makeSentence([code.quantite, conditionnement, sentence]) + conditionnementForCommande
  },
  retreiveSentence(code, fiskeyboard, idCodeMagasin) {
    const state = KeyboardService.retrieveState(code.idCode, code.idDenomination, fiskeyboard, idCodeMagasin)
    return SentenceUtils.makeSentenceWithState(state)
  },
  generateResultWithDisplay(state, input, fishDatabase, arrCode, filteringFn) {
    return KeyboardService.generateResult(state, input, fishDatabase, arrCode, filteringFn)
  },

  filterAndFormat: (result, input, state, codePoisson, fishDatabase, filteringFn) => {
    const filtered = filteringFn(state, result, codePoisson)
    const nonCreatedProduct = (() => {
      if (result.length - filtered.length < 20 && input != '') {
        const nonFiltered = result.filter(statePart => !filtered.includes(statePart))
        return nonFiltered
      }
      return []
    })()

    const formatedResult = [].concat(
      KeyboardService.formatResultToDisplay(filtered, fishDatabase),
      KeyboardService.formatCreateToDisplay(nonCreatedProduct, fishDatabase)
    )
    return formatedResult
  },

  getCode: (state, fishDatabase) => {
    const stateWithEntier = KeyboardService.addEntier(state, fishDatabase)
    const stateIdCode = state.find(searchable => searchable.idCode)
    if (stateIdCode) {
      return stateIdCode
    }
    return KeyboardService.equalsCode(stateWithEntier, fishDatabase.codePoisson)
  },
  // TODO : Please write docs
  equalsCode: (state, codesBase) => codesBase.find(code => Object.keys(code).reduce((validator, stateElement) => {
    if (KeyboardService.ignoreProps.find(ign => ign === stateElement)) {
      return validator && true
    }

    const attr = state.find(st => st.getIdAttribute() === stateElement) || {}
    if (attr[stateElement] && code[stateElement]) {
      return validator && (attr[stateElement] === code[stateElement])
    } if (!!attr[stateElement] !== !!code[stateElement]) {
      return false
    }
    return validator && true
  }, true)),
  retreiveKeyboardCode: (idCode, idDenomination, idCodeMagasin, fishDatabase, raccourci = false) => {
    const state = KeyboardService.retrieveState(idCode, idDenomination, fishDatabase, idCodeMagasin)
    const flattenState = state.map(stateElement => {
      if (stateElement.getIdAttribute() === 'idPoisson') {
        if (idDenomination) {
          return new Poisson({...stateElement, nom: stateElement.denom.find(denomination => denomination.idDenominationPoisson === idDenomination).nom}).formatToDisplay()
        }
        return new Poisson({...stateElement, nom: stateElement.denom[0].nom}).formatToDisplay()
      }
      return stateElement
    })
    const text = (flattenState[0] && flattenState[0].idProduitTransforme) ? flattenState[0].nom : SentenceUtils.makeSentenceWithState(flattenState, raccourci)
    const fullText = (flattenState[0] && flattenState[0].idProduitTransforme) ? flattenState[0].nom : SentenceUtils.makeSentenceWithState(flattenState, false)

    return {
      idCode,
      idDenomination,
      idCodeMagasin,
      text,
      fullText
    }
  },
  retreiveCodeWithIdMagasin: (rawCode, fishDatabase) => {
    const code = [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(codeLine => codeLine.idCode === (rawCode.idCode || rawCode.code.idCode) && codeLine.idCodeMagasin === (rawCode.idCodeMagasin || rawCode.code.idCodeMagasin))
    if (!code) { return { } }
    const poisson = fishDatabase.poisson.find(poissonLine => code.idPoisson === poissonLine.idPoisson)
    return {...code, idCategoriePoisson: poisson ? poisson.idCategoriePoisson : undefined}
  },
  retreiveCode: (rawCode, fishDatabase, idCodeMagasin) => {
    if (rawCode && rawCode.idCode) {
      return rawCode
    }

    const code = (() => {
      if (idCodeMagasin) {
        return [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(codeLine => codeLine.idCodeMagasin === idCodeMagasin)
      }
      return [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(codeLine => codeLine.idCode === rawCode)
    })()
    if (!code) { return { } }
    const poisson = [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(poissonLine => code.idPoisson === poissonLine.idPoisson && !code.idProduitLS)

    return {...code, idCategoriePoisson: poisson ? poisson.idCategoriePoisson : undefined}
  },
  retrieveState: (rawCode, idDenomination, fishDatabase, idCodeMagasin) => {
    const code = KeyboardService.retreiveCode(rawCode, fishDatabase)
    const conditionnement = fishDatabase.conditionnement.find(element => (element[element.getIdAttribute()] === (code.idConditionnement !== null ? code.idConditionnement : 1)))
    const entier = fishDatabase.conditionnement.find(element => (element[element.getIdAttribute()] === 1))
    const poisson = fishDatabase.poisson.find(el => (el.idPoisson === code.idPoisson))
    const produitTransforme = fishDatabase.produitTransforme.find(el => (el.idProduitTransforme === code.idProduitTransforme))
    const codeMagasinLS = fishDatabase.produitLS.filter(produitLS => produitLS.idCode === rawCode)
    const codeMagasinValue = codeMagasinLS.length > 0 ? codeMagasinLS[0].idCodeMagasin : idCodeMagasin
    const codeMagasin = [...fishDatabase.codePoisson, ...fishDatabase.produitLS].find(codePoisson => (codePoisson.idCodeMagasin === codeMagasinValue))
    const produitLS = codeMagasin ? fishDatabase.produitLS.find(produitLs => produitLs.idProduitLS === codeMagasin.idProduitLS) : null


    const selectedDenom = (() => {
      if (produitLS) {
        return produitLS.nom
      }
      if (poisson && !produitLS) {
        const idDenom = poisson.denom.find(el => el.idDenominationPoisson === idDenomination)
        if (idDenom) {
          return idDenom
        }
        return poisson.denom[0]
      } if (produitTransforme) {
        return produitTransforme.nom
      }
    })()

    const finalStatePart = (() => {
      if (poisson && !produitLS) {
        const finalFish = new Poisson({
          ...poisson,
          denom: [selectedDenom],
          raccourci: selectedDenom.raccourci
        })
        return [conditionnement, finalFish]
      }
      if (produitTransforme) {
        return [conditionnement, produitTransforme]
      }
      if (produitLS) {
        return [produitLS]
      }
      return conditionnement ? [conditionnement] : []
    })()
    const statePart = Object.entries(code).filter(element => !(element[0] === 'code') && !(element[0] === 'idCode') && !(element[0] === 'idPoisson') && element[1])
    const final = statePart.reduce(prec => prec.concat(KeyboardService.generateResult(prec, '', fishDatabase, [code]).filter(statePart => statePart.created)), KeyboardService.formatResultToDisplay(finalStatePart, fishDatabase))
    return finalStatePart.filter(keyboard => Object.keys(keyboard).includes('idProduitLS')).length > 0 ? KeyboardService.formatResultToDisplay(finalStatePart, fishDatabase) : final.filter(part => part.idConditionnement !== KeyboardService.idEntier)
  },

  // add entier if there are idPoisson but no idConditionnement
  addEntier: (state, fishDatabase) => {
    const stateIdPoisson = state.find(searchable => searchable.idPoisson || searchable.idProduitTransforme || searchable.idProduitLS)
    const stateConditionnement = state.find(searchable => searchable.idConditionnement)
    if (stateIdPoisson && !stateConditionnement) {
      return [].concat(state, [fishDatabase.conditionnement.find(cond => cond.idConditionnement === KeyboardService.idEntier)])
    }
    return state
  },

  checkEntier: (state, fishDatabase) => {
    if (state.length === 0) {
      return state.concat([fishDatabase.find(el => parseFloat(el.idConditionnement) === KeyboardService.idEntier)])
    }
    return state
  },

  // all Getter with condition
  getQualite: (state, input, fishDatabase) => {
    if (KeyboardService.isAttribute(state, 'idPoisson')) {
      const filteredQualite = SentenceUtils.searchOnTab(fishDatabase, input, 'nom')
      return filteredQualite
    }
    return []
  },

  getPreparation: (state, input, fishDatabase) => {
    if (KeyboardService.isAttribute(state, 'idPoisson')
      || KeyboardService.isAttribute(state, 'idTaille')
      && !KeyboardService.haveAttribute(state, 'idPreparation')) {
      const filteredPreparation = SentenceUtils.searchOnTab(fishDatabase, input, 'nom')
      return filteredPreparation
    }
    return []
  },

  getLabel: (state, input, fishDatabase) => {
    if (KeyboardService.haveAttribute(state, 'idPoisson') && !KeyboardService.haveAttribute(state, 'idLabel')) {
      const filteredLabel = SentenceUtils.searchOnTab(fishDatabase, input, 'nom')
      return filteredLabel
    }
    return []
  },

  getOrigine: (state, input, fishDatabase) => {
    if (((KeyboardService.isAttribute(state, 'idPoisson') && !KeyboardService.isHuitre(state))
      || (KeyboardService.isHuitre(state) && KeyboardService.isAttribute(state, 'idQualite'))) && !KeyboardService.haveAttribute(state, 'idOrigine')) {
      const filteredOrigine = SentenceUtils.searchOnTab(fishDatabase, input, 'nom')
      return filteredOrigine
    }
    return []
  },

  getTaille: (state, input, fishDatabase) => {
    if (
      (KeyboardService.isAttribute(state, 'idPoisson') && !KeyboardService.isHuitre(state))
      || (KeyboardService.isHuitre(state) && KeyboardService.isAttribute(state, 'idOrigine'))
      || (KeyboardService.isAttribute(state, 'idPreparation') && !KeyboardService.haveAttribute(state, 'idTaille'))
    ) {
      const filteredTaille = SentenceUtils.searchOnTab(fishDatabase, input, 'taille')
      return filteredTaille
    }
    return []
  },

  getConditionnement: (state, input, fishDatabase) => {
    if ((state.length === 0 || state[0].idConditionnement === KeyboardService.idEntier && !state[1]) && !KeyboardService.isAttribute(state, 'idCode') && !KeyboardService.haveAttribute(state, 'idProduitLS')) {
      return SentenceUtils.searchOnTab(fishDatabase, input, 'nom').filter(cond => cond.idConditionnement !== KeyboardService.idEntier)
    }
    return []
  },


  getProduitTransforme: (state, input, fishDatabase) => {
    if (!KeyboardService.isAttribute(state, 'idCode') && !KeyboardService.haveAttribute(state, 'idPoisson') && !KeyboardService.isAttribute(state, 'idProduitTransforme') && !KeyboardService.haveAttribute(state, 'idProduitLS')) {
      const filteredOrigine = SentenceUtils.searchOnTab(fishDatabase.filter(fish => !!fish.nom), input, 'nom')
      return filteredOrigine
    }
    return []
  },

  getProduitLS: (state, input, fishDatabase) => {
    if (!KeyboardService.isAttribute(state, 'idCode') && !KeyboardService.haveAttribute(state, 'idPoisson') && !KeyboardService.isAttribute(state, 'idProduitLS') && !KeyboardService.isAttribute(state, 'idProduitTransforme')) {
      const filteredOrigine = SentenceUtils.searchOnTab(fishDatabase.filter(fish => !!fish.nom), input, 'nom')
      return filteredOrigine
    }
    return []
  },

  getPoisson: (state, input, fishDatabase) => {
    const newArrFish = () => fishDatabase.reduce((arr, fish) => {
      const latinArr = (sl => {
        if (sl.length > 0) {
          return [].concat(fish.denom)
        } return []
      })(SentenceUtils.searchOnTab(fish.latin, input, 'nom'))

      const denomArr = (() => SentenceUtils.searchOnTab(fish.denom, input, 'nom'))()

      const finalDenom = [].concat(denomArr, latinArr).reduce((arr, el) => {
        if (arr.find(arrEl => arrEl.idDenominationPoisson === el.idDenominationPoisson)) { return arr } return [].concat(arr, [el])
      }, []).map(denomi => new Poisson(Object.assign({}, fish, {denom: [denomi], raccourci: denomi.raccourci})))

      return [].concat(arr, finalDenom)
    }, [])
    if (KeyboardService.isAttribute(state, 'idConditionnement')) {
      return newArrFish()
    }
    return []
  },
  getByCode: (state, input, fishDatabase, codePoisson = fishDatabase.codePoisson) => {
    if (state.length === 0) {
      const matchs = SentenceUtils.matcher.numberMatcher(codePoisson, input, 'plu')

      const fishResult = Array.from(new Set(matchs.map(match => match.plu)))
        .map(plu => matchs.find(match => match.plu === plu))
        .filter(fish => fish && fishDatabase.poisson.find(fishCode => fishCode.idPoisson === fish.idPoisson))
        .map(fish => fishDatabase.poisson.find(fishCode => fishCode.idPoisson === fish.idPoisson).denom
          .map(denom => {
            const code = fish
            const retreivedState = KeyboardService.retrieveState(code.idCode, denom.idDenominationPoisson, fishDatabase)
            const nom = SentenceUtils.makeSentenceWithState(retreivedState)
            const tmp = {
              ...code,
              nom,
              idDenomination: denom.idDenominationPoisson
            }
            return new PoissonCode(tmp)
          }))
        .reduce((arr, el) => arr.concat(el), [])

      const produitTransformeResult = matchs
        .filter(fishCode => fishDatabase.produitTransforme.find(produitTransfo => fishCode.idProduitTransforme === produitTransfo.idProduitTransforme))
        .reduce((arr, el) => arr.concat(el), [])
        .map(fishCode => {
          const found = fishDatabase.produitTransforme.find(produitTransfo => fishCode.idProduitTransforme === produitTransfo.idProduitTransforme)
          const newCode = {...fishCode, nom: found.nom}
          return new PoissonCode(newCode)
        })

      const produitLSResult = matchs
        .filter(fishCode => fishDatabase.produitLS.find(produitLS => fishCode.idProduitLS === produitLS.idProduitLS))
        .reduce((arr, el) => arr.concat(el), [])
        .map(fishCode => {
          const found = fishDatabase.produitLS.find(produitLS => fishCode.idProduitLS === produitLS.idProduitLS)
          const newCode = {...fishCode, nom: found.nom}
          return new PoissonCode(newCode)
        })

      return [].concat(fishResult, produitTransformeResult, produitLSResult)
    }
    return []
  },


  isAttribute: (state, element) => state.length !== 0 && state[state.length - 1].getIdAttribute() === element,

  haveAttribute: (state, element) => state.length !== 0 && state.find(stateel => stateel.getIdAttribute() === element),

  getAttribute: (state, element) => state.find(el => el.getIdAttribute() === element),

  isHuitre: state => (state.length !== 0) && (!!state.find(element => element.getIdAttribute() === 'idPoisson' && KeyboardService.idHuitre.find(id => element.idPoisson === id)))
}

export default KeyboardService
